import { get } from 'lodash'

const getEnvironmentVariable = name =>
  get(window.env, name) || get(process.env, name)

export default getEnvironmentVariable
